import React from "react";
import bacteria from "../assets/articale/1.jpg";
import arrowup from "../assets/arrowblue.png";
import ref from "../assets/ref.webp";
import { symptoms } from "../constant/data";
import MedicalArtical from "./medicalArtical";
import LungInfographic from "./lungInfographic";
import NaturalSolution from "./NaturalSolution";
import LungsRestore from "./LungsRestore";
import GradeTechnology from "./GradeTechnology";
import BreatheFreely from "./BreatheFreely";
import GetYourHands from "./GetYourHands";
import JustAboutYou from "./JustAboutYou";
import Discount from "./discount";

const Blogs = () => {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <p className="md:text-4xl text-2xl">
          <span className="font-bold">{"NEW DISCOVERY:"}</span>{" "}
          {
            "Breathe Freely Again With This ‘Lost Herb’ That’s Revolutionizing Respiratory Health in Just Days!"
          }
        </p>
        <p className=" font-bold" style={{ fontSize: "16px" }}>
          <span className="bg-[#ffbf00]">
            {
              " If you have difficulty breathing, suffer from shortness of breath, cough, wheezing, frequent colds, or chronic respiratory issues,"
            }  
          </span>  
          {" read this article right now before you do anything else."}
        </p>
        <div className="flex items-center">
          <span className="text-xl text-yellow-400">⭐⭐⭐⭐⭐</span>
          <span className="ml-2 text-sm text-[#007185]">{"3,791 Ratings"}</span>
        </div>
      </div>  
      <div>
        <div className="rounded-lg overflow-hidden mb-4">
          <img
            src={bacteria}
            alt="Medical illustration showing respiratory infection with magnified bacteria view"
            className="w-full rounded-3xl border border-gray-100"
            draggable="false"  
          />
        </div>
        <div className="flex items-center mb-4">  
          <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 mr-3">
            <img
              src={ref}
              alt="Laura Foster"
              className="w-full h-full object-cover"
              draggable="false"
            />
          </div>
          <div className="text-[#303030] md:text-[18px] text-xs">   
            <span>{"By Laura Foster / Medical Journalist"}</span>
          </div>
          <div className="md:ml-10 ml-auto flex items-center gap-2  px-2 py-1 rounded-full text-xs">
            <div>
              <img
                src="https://img.funnelish.com/19232/185804/1725372175-verified1.jpg"
                alt=""    
                className="h-6 w-6 object-contain"
                draggable="false"
              />  
            </div>
            <span className="md:text-lg text-xs text-[#303030]">
              {" "}
              <i>{"March 3, 2025"} </i>{" "}  
            </span>
          </div>
        </div> 
        <div className="space-y-4 text-[#303030]">
          <p>
            <span className="font-bold">
              {"“We finally cracked the code on respiratory health.”"}{" "}
            </span>
            {" This is how"}
            <span className="font-bold">{" Dr. Ali,"} </span>
            {" spokesperson for "}     
            <span className="font-bold">{" Herbal Tea Therapy, "} </span>
            {
              " introduced their revolutionary product just weeks after its launch."
            }{" "}
            <span className="text-bold">   
              {" Herbal Tea Therapy’s Breathe "}
            </span>{" "}  
            {  
              "has already caught national attention for its powerful, all-natural ingredients that promise to restore healthy breathing for anyone suffering from respiratory issues."
            }
          </p>
          <p>
            <span className="font-bold">
              {"“During my career, I have helped more than 2,000 patients "} 
            </span>{" "}  
            {
              "patients who have come to me with all types of respiratory problems,” he explains, his only regret being not developing this tincture sooner. After more than 20 years in the business, he has seen it all—just to name a few:   "
            }  
          </p>  
        </div>
      </div>
      <div className="bg-[#e2f4f9] p-4">  
        {symptoms.map((symptom, index) => (
          <div
            key={index}
            className="flex items-center gap-3 mb-4 last:mb-0 text-lg"
          >
            <div className="flex-shrink-0">
              <img
                src={arrowup}
                alt=""
                className="w-10 h-10"
                draggable="false"
              />
            </div>
            <span className="text-[#303030] font-bold">{symptom}</span>
          </div>
        ))}
      </div>
      <p>
        {
          "“You name it, I’ve seen it all. From a simple cough to almost complete lung tissue die-off. I have seen and felt the patients struggle through the years. But today, we have found a companion that we believe should be in everyone’s medical cabinet.”"
        }
      </p>
      <MedicalArtical />
      <LungInfographic />
      <NaturalSolution />
      <LungsRestore />
      <GradeTechnology />
      <BreatheFreely />
      <GetYourHands />
      <JustAboutYou />
      <Discount />
    </div>
  );
};

export default Blogs;
